import React from "react";
import { ArrowUpRight } from "lucide-react";
import type { ProgressDetails } from "../types";

interface ProgressPanelProps {
  progress: ProgressDetails;
}

export const ProgressPanel: React.FC<ProgressPanelProps> = ({ progress }) => {
  const { progressPercent, text, badge } = progress;

  return (
    <div className="p-6 flex flex-col justify-between lg:col-span-2">
      <div>
        <div className="text-[#6B7280] font-bold text-[13px] tracking-wider uppercase">
          Campaign Progress
        </div>
        <div className="flex items-center gap-3 mt-4">
          <span className="text-5xl font-extrabold text-slate-900 tracking-tight">
            {progressPercent}%
          </span>
          <span
            className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-[12px] font-semibold ${
              badge === "Completed"
                ? "bg-emerald-100 text-emerald-700"
                : badge === "Paused"
                  ? "bg-amber-100 text-amber-700"
                  : "bg-emerald-100 text-emerald-700"
            }`}
          >
            {badge}
            {badge !== "Paused" && <ArrowUpRight className="w-4 h-4" />}
          </span>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-slate-100 h-3 rounded-full overflow-hidden mt-4">
          <div
            className="bg-[#A655F8] h-full rounded-full transition-all duration-500"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>
      <div className="text-slate-500 text-[14px] font-medium mt-3">
        {text}
      </div>
    </div>
  );
};
